import { useContext } from "react";
import { PaginationContext } from "../context";

export const usePagination = () => useContext(PaginationContext);
